import { render, staticRenderFns } from "./ActivityConfigView.vue?vue&type=template&id=e90dc6b4&scoped=true"
import script from "./ActivityConfigView.vue?vue&type=script&lang=js"
export * from "./ActivityConfigView.vue?vue&type=script&lang=js"
import style0 from "./ActivityConfigView.vue?vue&type=style&index=0&id=e90dc6b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90dc6b4",
  null
  
)

export default component.exports